import React from 'react';

import { useMount } from 'react-use';

import { useAppSelector } from 'hooks';
import { useLogout } from 'hooks';

import InfoBox from './InfoBox';

const ThankYou = () => {
  const { logout } = useLogout();
  const accessToken = useAppSelector((state) => state.oauth.data?.access_token);

  useMount(() => {
    if (accessToken) {
      logout();
    }
  });

  return <InfoBox dataTestId="thank-you-box" title="thankYou" description="safelyCloseKey" />;
};

export default ThankYou;
